import { COUNTRIES } from "../shared/constants";
import { MAIN_ENV } from "constants/global.constants";

export const getCountry = () => {
  const currentCountry = MAIN_ENV.COUNTRY ?? COUNTRIES.CO.LABEL;
  return currentCountry;
};

export const isDefaultCountry = () => {
  return getCountry() === COUNTRIES.CO.LABEL;
};
